const zhAbout = {
  header: {
    label: '关于我们',
    title: '韩漫大全',
    titleAccent: '让每一部好漫画被看见',
    desc: '韩漫大全成立于2020年，致力于为广大中文读者提供最全面的韩国漫画在线阅读服务。我们与多家韩国漫画平台合作，每日更新热门连载，收录海量经典完结作品，打造中文世界最优质的韩漫阅读社区。',
    contactLink: '联系我们',
    stats: {
      founded: '成立年份',
      users: '累计用户',
      works: '收录作品',
      dailyActive: '日活跃读者',
    },
  },
  features: {
    title: '我们的优势',
    feature1: {
      title: '海量资源',
      desc: '收录超过3000部韩国漫画作品，涵盖恋爱、奇幻、动作、悬疑等多种题材，每日持续更新。',
      icon: 'ri-stack-line',
    },
    feature2: {
      title: '极速更新',
      desc: '与韩国同步更新，第一时间带来最新连载章节，让漫友不再错过任何精彩内容。',
      icon: 'ri-flashlight-line',
    },
    feature3: {
      title: '优质体验',
      desc: '高清画质、流畅翻页、智能推荐，为漫友打造沉浸式的在线阅读体验。',
      icon: 'ri-device-line',
    },
    feature4: {
      title: '社区互动',
      desc: '百万漫友聚集地，评论、评分、推荐，找到志同道合的读漫伙伴。',
      icon: 'ri-group-line',
    },
  },
  mediaReviews: {
    title: '媒体与口碑',
    review1: {
      text: '韩漫大全以其丰富的资源和优秀的用户体验，成为中文韩漫爱好者首选的阅读平台之一。',
      source: '动漫资讯网',
      role: '媒体评测',
    },
    review2: {
      text: '更新速度快、画质清晰、分类齐全——这是韩漫大全给读者最直观的三个印象标签。',
      source: '二次元观察',
      role: '行业媒体',
    },
    cta: '查看全部报道',
  },
  cta: {
    line1: '让我们一起',
    line2: '共创韩漫美好未来',
    line3: '合作、投稿、反馈，期待你的声音',
    btn: '商务合作',
  },
};

export default zhAbout;